import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SideMenuService {

  constructor(private http: HttpClient) { }
  public authLocalStorageTokenKey = 'token'
  private menuUpdateSource = new Subject<void>();
  menuUpdated$ = this.menuUpdateSource.asObservable();

  httpHeaderOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem(this.authLocalStorageTokenKey)}`
    }),
  };

  triggerMenuUpdate() {
    this.menuUpdateSource.next();
  }


  fetchSideMenu(): Observable<any> {
    return this.http.get<any>(`${environment.baseURL}/fetch-menu/`, this.httpHeaderOptions)
  }
}
